// 생산실적 조회 DTO (일자별/품목별/공정별) - 컬럼 명세에 맞춘 camelCase 필드

import { ProductResultDto } from 'src/dtos/productResult/ProductResultDto';
import { formatDate, toLocalDateTime } from 'src/utils/string/stringUtil';
import { PRD3040_R01_SUBTOTAL_TYPES, PRD3040_R01SubtotalRow } from './utils/subtotalUtils';
// 소계 관련 타입들 (subtotalUtils.ts에서 import)
export { 
    PRD3040_R01isSubtotalRow as isSubtotalRow, 
    PRD3040_R01isDateSubtotalRow as isDateSubtotalRow, 
    PRD3040_R01isItemSubtotalRow as isItemSubtotalRow, 
    PRD3040_R01isWorkplaceSubtotalRow as isWorkplaceSubtotalRow,
    mergeDataWithSubtotals,
    getSubtotalCalculator
} from './utils/subtotalUtils';


export interface DateProductResultDto extends ProductResultDto {
}

export interface ItemProductResultDto extends ProductResultDto {    
}

export interface WorkplaceProductResultDto extends ProductResultDto {
}

// 통합 DTO (서버 응답 제네릭을 위한 공통 타입)
export type PRD3040_R01Dto = DateProductResultDto | ItemProductResultDto | WorkplaceProductResultDto;


// 통합 그리드 데이터 타입
export type GridRowData = PRD3040_R01Dto | PRD3040_R01SubtotalRow;

export const defaultGridRowData: GridRowData = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',
	
    isSubtotal: true,
    subtotalType: PRD3040_R01_SUBTOTAL_TYPES.DATE,
    groupKey: '',
    groupLabel: '',
    count: 0,

	

	inserted: false,
	isModified: false,
}

// 기본값
export const defaultDateProductResult: DateProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inserted: false,
	isModified: false,
};

export const defaultItemProductResult: ItemProductResultDto = {	
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',
	
	inserted: false,
	isModified: false,
};

export const defaultWorkplaceProductResult: WorkplaceProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',
	
	inserted: false,
	isModified: false,
}
